import axios from '@src/public/utils/request';

// 加入追踪
export const followTimeline = id => {
    return axios.post('/timeline/front/api/follows', {
        timelineId: id,
    });
};

// 取消追踪
export const cancelFollowTimeline = id => {
    return axios.delete('/timeline/front/api/follows', {
        data: { timelineId: id },
    });
};

// 评论弹幕接口
export const getCommonList = ({ id, size, isWarPage }) => {
    // mock
    // return axios.get(`https://api.ifengcloud.ifeng.com/mock/1749/timeline/front/api/timelines/${id}/bullet-comments`, {
    //     params: { size },
    // });

    let normalUrl = `https://external-gateway.ifengidc.com/timeline/front/api/timelines/${id}/bullet-comments`;

    // console.log(isWarPage, 'isWarPage')
    if (isWarPage) {
        normalUrl = `https://shankapi.ifeng.com/api/timeline/danmu_${id}/info`;
    }

    const result = axios.get(normalUrl, {
        params: { size },
    });

    return result;
};

// 获取节点定位接口
export const getNodePosition = nodeId => {
    return axios.get(`/timeline/front/api/nodes/${nodeId}/position`);
};
